<template>
  <div class="not-found">
    <div class="heading primary-yellow-text">Not Found</div>
  </div>
</template>

<style scoped>
.not-found {
  text-align: center;
  padding: 2rem;
}
</style>
